import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDocumentsList,
  getFileUploadSignedUrl,
  getViewFileSignedUrl,
  getDownloadSignedUrl,
  getDeleteSignedUrl,
  getSignedUrlList,
  postSavedUploadedFile,
  getUploadedFileById,
  deleteFileById,
  submitDocument,
  saveRowUndertaking,
  postFinalLicense,
  postFinalLicenseRow,
  postCircleRateUpdate,
} from "../../services/apiEndPoints";
import { StepIconClassKey } from "@mui/material";

type DocumentsListPayload = {
  category_id: number;
  access_id: any;
};

type DocumentsPayload = {
  category_id: number;
  access_id: any;
  document: string;
};

export const getDocumentsListThunk = createAsyncThunk(
  "row/getDocumentsList",
  async (payload: DocumentsPayload) => {
    const { category_id, access_id, document } = payload;
    try {
      const response = await getDocumentsList(category_id, access_id, document);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileUploadSignedURLThunk = createAsyncThunk(
  "row/getFileUploadSignedURL",
  async ({
    fileName,
    fileSize,
    contentType,
    isEsign,
  }: {
    fileName: string;
    fileSize: string;
    contentType: string;
    isEsign?: boolean;
  }) => {
    try {
      const response = await getFileUploadSignedUrl(
        fileName,
        fileSize,
        contentType,
        isEsign,
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileSignedURLThunk = createAsyncThunk(
  "row/getFileSignedURL",
  async ({ document_name }: { document_name: string }) => {
    try {
      const response = await getViewFileSignedUrl(document_name);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileSignedURLMorthThunk = createAsyncThunk(
  "row/getFileSignedURLMorth",
  async ({ document_name }: { document_name: string }) => {
    const response = await getViewFileSignedUrl(document_name, "morth");
    return response.data;
  },
);

export const getDownloadSignedURLThunk = createAsyncThunk(
  "row/getDownloadSignedURL",
  async ({ document_name }: { document_name: string }) => {
    try {
      const response = await getDownloadSignedUrl(document_name);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getDeleteSignedURLThunk = createAsyncThunk(
  "row/getDeleteSignedURL",
  async (fileName: StepIconClassKey) => {
    try {
      const response = await getDeleteSignedUrl(fileName);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getSignedURLListThunk = createAsyncThunk(
  "row/getSignedURLList",
  async () => {
    try {
      const response = await getSignedUrlList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const postSaveUploadedFileThunk = createAsyncThunk(
  "row/postSaveUploadedFile",
  async (payload: any) => {
    try {
      const response = await postSavedUploadedFile(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const saveRowUndertakingThunk = createAsyncThunk(
  "row/saveRowUndertaking",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await saveRowUndertaking(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed to save undertaking",
      );
    }
  },
);

export const getUploadedFileByIdThunk = createAsyncThunk(
  "row/getUploadedFileById",
  async (payload: any) => {
    const { access_id, category_id, document } = payload;
    try {
      const response = await getUploadedFileById(
        access_id,
        category_id,
        document,
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const deleteFileByIdThunk = createAsyncThunk(
  "row/deleteFileById",
  async (payload: any) => {
    const { access_id, document_id } = payload;
    try {
      const response = await deleteFileById(access_id, document_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const submitDocumentThunk = createAsyncThunk(
  "row/submitDocument",
  async (payload: DocumentsListPayload) => {
    const { access_id, category_id } = payload;
    try {
      const response = await submitDocument(access_id, category_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const postFinalLicenseThunk = createAsyncThunk(
  "row/postFinalLicense",
  async (payload: any) => {
    try {
      const response = await postFinalLicense(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const postFinalLicenseRowThunk = createAsyncThunk(
  "row/postFinalLicenseRow",
  async (payload: any) => {
    try {
      const response = await postFinalLicenseRow(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const postCircleRateUpdateThunk = createAsyncThunk(
  "row/postCircleRateUpdate",
  async (payload: any) => {
    try {
      const response = await postCircleRateUpdate(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);
